import { AxiosError } from 'axios';
import { useCallback } from 'react';

type AxiosErrorWithResponseErrorField = {
  response: NonNullable<AxiosError<{ error: unknown }>['response']>;
} & Omit<AxiosError, 'response'>;

export const useUseIsAxiosErrorWithResponseErrorField = () =>
  useCallback(
    (error: unknown): error is AxiosErrorWithResponseErrorField =>
      error instanceof AxiosError &&
      Boolean(error.response?.data) &&
      typeof error.response?.data === 'object' &&
      'error' in error.response.data,
    [],
  );
